import type { TCountryCode } from 'countries-list';

export const supportedCountries: TCountryCode[] = [
  'AT',
  'AU',
  'BE',
  'BR',
  'BG',
  'CA',
  'CL',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IE',
  'IL',
  'IT',
  'JP',
  'LV',
  'LT',
  'LU',
  'MY',
  'MT',
  'MX',
  'NL',
  'NZ',
  'NO',
  'PL',
  'PT',
  'RO',
  'SG',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'TH',
  'AE',
  'GB',
  'US',
];
